import { render } from "./admin-sdk-devices.vue?vue&type=template&id=7bd4ff10&scoped=true"
import script from "./admin-sdk-devices.vue?vue&type=script&lang=js"
export * from "./admin-sdk-devices.vue?vue&type=script&lang=js"

import "./admin-sdk-devices.vue?vue&type=style&index=0&id=7bd4ff10&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd4ff10"]])

export default __exports__